import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'sms-editor',
    template: `
    <div class='sms-editor'>
        <div class='sub-title'>Edit SMS</div>
        <textarea [(ngModel)]="text" (ngModelChange)="onChange($event)"></textarea>
        <div class="options">
            <div>
                <span>
                    {{current}} / {{sms_total}}
                </span>
                <span>
                    {{parts}} Parts
                </span>
            </div>
        </div>
    </div>
    `,
    styles: [`
        textarea {
            min-width: 300px;
        }
    `]
})
export class SmsComponent {

    public text: string;
    public current: number = 0;
    public sms_total: number = 0;
    public parts: number = 1;
    constructor() { }


    public onChange(event: any) {
		if (event && event.trim()) {
			let flag = event.match(/[^\x00-\xff]/g); // Detect if any double-byte character included
			this.calculateParts(event, flag && flag.length);

		}
		else {
			this.current = 0;
			this.parts = 1;
			this.sms_total = 160;
		}
    }

    public calculateParts(message: string, double_byte: boolean) {
		this.current = message.length;
		let single_length: number = double_byte ? 70 : 160;
		let part_length: number = double_byte ? 67 : 153;
		if (this.current && this.current <= single_length) {
			this.sms_total = single_length;
			this.parts = 1;
		}
		else {
			this.parts = 1;
			do {
				this.parts++;
				this.sms_total = Number(this.parts * part_length);
			} while (this.sms_total < this.current);
		}
    }
}
